/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsProductTypeListItem,
    DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSON,
    DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsProductTypeListItemToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsProductTypeListItem>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsProductTypeListItem>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsProductTypeListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItemToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsProductTypeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsProductTypeListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


